// Мост «страна × язык каталога» → код вкладки клиентского трекера.
//
// Трекер (книга «Pothos internal tracker», лист-источник `Asset_Tracker
// (Combined)`) считает 35 ячеек сбора. Наш каталог хранит страну и язык
// ПОЛНЫМИ ИМЕНАМИ и в двух написаниях — через пробел и через подчёркивание
// («Hong Kong» / «Hong_Kong»), — поэтому lookup нормализуется.
//
// НОРВЕЖСКИЙ — ОДНА локаль с ЧЕТЫРЬМЯ странами сбора и ЕДИНОЙ квотой
// (Глеб, 2026-08-01): Дания, Канада, Швеция, Британия. Распределения по
// странам нет — собирать можно в любой из них, значение имеет общий объём.
// Норвежский материал это билеты норвежскоязычных покупателей на события
// в ДРУГИХ странах, поэтому самой Норвегии среди стран сбора НЕТ.
//
// Четыре вкладки трекера (`nb_DK`/`nb_CA`/`nb_SE`/`nb_GB`) — это РАЗРЕЗ ДЛЯ
// ОТЧЁТА, а не четыре независимые квоты: их цели по 1796 в сумме дают 7184,
// ровно объём одной обычной локали. Не заводи по ним отдельные плановые
// ячейки — см. NORWEGIAN_TRACKER_TABS ниже и README слайса shipexport.
//
// Пара ('Norway','Norwegian') СОЗНАТЕЛЬНО отсутствует: страна Norway в
// каталоге — всегда ошибка разметки (packaging.ts NORWAY_RE помечает такой
// кадр дырой `country`), и молча увести её в несуществующую ячейку `nb_NO`
// значит спрятать ошибку вместо того, чтобы её показать.
const TRACKER_LOCALES: Record<string, string> = {
  'saudi arabia|arabic': 'ar_SA',
  'united arab emirates|arabic': 'ar_AE',
  'uae|arabic': 'ar_AE',
  'denmark|danish': 'da_DK',
  'switzerland|german': 'de_CH',
  'germany|german': 'de_DE',
  'chile|spanish': 'es_CL',
  'spain|spanish': 'es_ES',
  'mexico|spanish': 'es_MX',
  'us|spanish': 'es_US',
  'usa|spanish': 'es_US',
  'united states|spanish': 'es_US',
  'finland|finnish': 'fi_FI',
  'canada|french': 'fr_CA',
  'france|french': 'fr_FR',
  'israel|hebrew': 'he_IL',
  'india|hindi': 'hi_IN',
  'indonesia|indonesian': 'id_ID',
  'indonesia|bahasa indonesia': 'id_ID',
  'switzerland|italian': 'it_CH',
  'italy|italian': 'it_IT',
  'japan|japanese': 'ja_JP',
  'south korea|korean': 'ko_KR',
  'malaysia|malaysian': 'ms_MY',
  'malaysia|malay': 'ms_MY',
  'canada|norwegian': 'nb_CA',
  'sweden|norwegian': 'nb_SE',
  'united kingdom|norwegian': 'nb_GB',
  'denmark|norwegian': 'nb_DK',
  'netherlands|dutch': 'nl_NL',
  'poland|polish': 'pl_PL',
  'brazil|portuguese brazil': 'pt_BR',
  'brazil|portuguese': 'pt_BR',
  'portugal|portuguese': 'pt_PT',
  'portugal|portuguese portugal': 'pt_PT',
  'sweden|swedish': 'sv_SE',
  'thailand|thai': 'th_TH',
  'turkey|turkish': 'tr_TR',
  'türkiye|turkish': 'tr_TR',
  'vietnam|vietnamese': 'vi_VN',
  'singapore|simplified chinese': 'zh_SG',
  'hong kong|traditional chinese': 'zh_HK',
  'taiwan|traditional chinese': 'zh_TW',
};

// 35 ячеек сбора — ровно те коды, по которым у трекера есть строка в «By
// locale» и собственная вкладка. Код вне этого набора в трекер уходить не
// должен: строка молча растворится в листе, которого нет.
export const TRACKER_CODES = [
  'es_ES', 'ja_JP', 'ko_KR', 'pt_PT', 'fr_FR', 'es_US', 'es_MX', 'es_CL', 'pt_BR', 'fr_CA',
  'zh_SG', 'vi_VN', 'tr_TR', 'zh_TW', 'zh_HK', 'nb_CA', 'nb_SE', 'nb_GB', 'nb_DK',
  'de_DE', 'de_CH', 'it_IT', 'it_CH', 'nl_NL', 'sv_SE', 'da_DK',
  'ar_SA', 'ar_AE', 'fi_FI', 'pl_PL', 'id_ID', 'ms_MY', 'he_IL', 'th_TH', 'hi_IN',
] as const;

const TRACKER_CODE_SET = new Set<string>(TRACKER_CODES);

// Четыре вкладки одной норвежской локали. Держим списком отдельно, чтобы
// любой отчёт мог схлопнуть их обратно в одну строку: квота у них общая.
export const NORWEGIAN_TRACKER_TABS = ['nb_DK', 'nb_CA', 'nb_SE', 'nb_GB'] as const;

function norm(s: string): string {
  return String(s || '').trim().toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ');
}

// '' — пара неизвестна или её ячейки в трекере нет. Пустая строка честнее
// догадки: неизвестную пару должен увидеть человек, а не тихо получить чужую
// вкладку.
export function trackerLocaleCode(country: string, locale: string): string {
  const code = TRACKER_LOCALES[`${norm(country)}|${norm(locale)}`] || '';
  return code && TRACKER_CODE_SET.has(code) ? code : '';
}

export function isTrackerCode(code: string): boolean {
  return TRACKER_CODE_SET.has(code);
}
